/* influencer-steps.js — controlador de passos para o Shopify Forms 96090.
 *
 * Regras inegociáveis:
 *  - Nunca remove campos do DOM.
 *  - Nunca intercepta submit — no último passo, o submit nativo do app é revelado.
 *  - Se o matching falhar (<10 campos casados), aborta silenciosamente e o
 *    fallback CSS deixa o formulário inteiro visível numa página só.
 */
(function () {
  'use strict';

  var STEP_MATCHERS = [
    { step: 1, keys: ['nome', 'sobrenome', 'e-mail', 'email', 'telefone', 'phone', 'first name', 'last name'] },
    { step: 2, keys: ['instagram', 'tiktok', 'visualiza', 'stories', 'midia kit', 'mídia kit', 'media kit'] },
    { step: 3, keys: ['por que', 'porque', 'embaixadora', 'autoriza'] },
    { step: 4, keys: ['cep', 'endereço', 'endereco', 'complemento', 'cidade', 'estado', 'address'] }
  ];
  var TOTAL_STEPS = 4;
  var MIN_FIELDS = 10;

  // Chaves reconhecidas pelo CSS para pareamento lado a lado.
  // Ordem importa: primeiro match ganha (sobrenome antes de nome).
  var FIELD_KEYS = [
    { key: 'sobrenome',  patterns: ['sobrenome', 'last name'] },
    { key: 'nome',       patterns: ['nome completo', 'nome', 'first name', 'primeiro nome'] },
    { key: 'email',      patterns: ['e-mail', 'email'] },
    { key: 'telefone',   patterns: ['telefone', 'celular', 'whatsapp', 'phone'] },
    { key: 'instagram',  patterns: ['instagram'] },
    { key: 'tiktok',     patterns: ['tiktok', 'tik tok'] },
    { key: 'cidade',     patterns: ['cidade'] },
    { key: 'estado',     patterns: ['estado', 'uf'] },
    { key: 'cep',        patterns: ['cep'] }
  ];

  function fieldKey(labelText) {
    var t = norm(labelText);
    if (!t) return null;
    for (var i = 0; i < FIELD_KEYS.length; i++) {
      var pats = FIELD_KEYS[i].patterns;
      for (var j = 0; j < pats.length; j++) {
        if (t.indexOf(norm(pats[j])) !== -1) return FIELD_KEYS[i].key;
      }
    }
    return null;
  }

  function norm(s) {
    return (s || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  function classify(labelText) {
    var t = norm(labelText);
    if (!t) return null;
    for (var i = 0; i < STEP_MATCHERS.length; i++) {
      var m = STEP_MATCHERS[i];
      for (var j = 0; j < m.keys.length; j++) {
        if (t.indexOf(norm(m.keys[j])) !== -1) return m.step;
      }
    }
    return null;
  }

  function fieldWrapper(labelEl, form) {
    // sobe até achar um bloco irmão dos outros campos; para no form.
    var el = labelEl;
    for (var i = 0; i < 6 && el && el !== form; i++) {
      var p = el.parentElement;
      if (!p || p === form) return el;
      // se o pai tem múltiplos labels, então "el" já é o wrapper
      if (p.querySelectorAll('label').length > 1) return el;
      el = p;
    }
    return labelEl;
  }

  function activate(root) {
    var form = root.querySelector('form');
    if (!form) return false;

    var labels = form.querySelectorAll('label');
    if (!labels.length) return false;

    // Cria os 4 wrappers de passo dentro do form (antes do submit)
    var stepEls = {};
    for (var s = 1; s <= TOTAL_STEPS; s++) {
      var d = document.createElement('div');
      d.setAttribute('data-step', String(s));
      if (s === 1) d.classList.add('is-active');
      stepEls[s] = d;
    }

    // Insere os steps antes do submit (ou no fim do form)
    var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    var anchor = submitBtn || null;
    for (var k = 1; k <= TOTAL_STEPS; k++) {
      if (anchor) form.insertBefore(stepEls[k], anchor);
      else form.appendChild(stepEls[k]);
    }

    // Classifica cada label e move o wrapper correspondente
    var moved = 0;
    var seen = new Set();
    labels.forEach(function (lb) {
      if (seen.has(lb)) return;
      var wrap = fieldWrapper(lb, form);
      if (!wrap || seen.has(wrap)) return;
      // Ignora se já é um step
      if (wrap.hasAttribute && wrap.hasAttribute('data-step')) return;
      var step = classify(lb.textContent) || 1;
      var fk = fieldKey(lb.textContent);
      if (fk && wrap.setAttribute) wrap.setAttribute('data-field-key', fk);
      stepEls[step].appendChild(wrap); // move preserva listeners e valores
      seen.add(wrap);
      moved++;
    });

    if (moved < MIN_FIELDS) {
      // Desfaz: move tudo de volta para o form, na ordem original é impossível,
      // mas o app tolera — só que preferimos abortar mantendo a estrutura original.
      // Como já mexemos, movemos filhos de volta pra manter o formulário funcional.
      for (var s2 = 1; s2 <= TOTAL_STEPS; s2++) {
        while (stepEls[s2].firstChild) form.insertBefore(stepEls[s2].firstChild, stepEls[s2]);
        stepEls[s2].remove();
      }
      return false;
    }

    // Marca pronto — CSS agora esconde os passos inativos
    root.classList.add('forms-steps-ready');
    var nav = root.querySelector('[data-nav]');
    if (nav) nav.hidden = false;

    setupNav(root, form, stepEls);
    setupCep(root, form);
    return true;
  }

  function setupNav(root, form, stepEls) {
    var current = 1;
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var count = root.querySelector('[data-count]');
    var tabs = root.querySelectorAll('[data-step-tab]');

    function render() {
      for (var s = 1; s <= TOTAL_STEPS; s++) {
        stepEls[s].classList.toggle('is-active', s === current);
      }
      tabs.forEach(function (t) {
        var s = Number(t.getAttribute('data-step-tab'));
        t.classList.toggle('is-current', s === current);
        t.classList.toggle('is-done', s < current);
      });
      if (count) count.textContent = 'Passo ' + current + ' de ' + TOTAL_STEPS;
      if (prev) prev.hidden = current === 1;
      root.classList.toggle('is-last', current === TOTAL_STEPS);
      try { history.replaceState(null, '', '#p' + current); } catch (e) {}
      // scroll ao topo do form
      var top = root.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function validateStep(s) {
      var fields = stepEls[s].querySelectorAll('input, select, textarea');
      var ok = true;
      fields.forEach(function (f) {
        if (f.disabled || f.type === 'hidden') return;
        if (typeof f.checkValidity === 'function' && !f.checkValidity()) {
          f.setAttribute('aria-invalid', 'true');
          if (typeof f.reportValidity === 'function' && ok) f.reportValidity();
          ok = false;
        } else {
          f.removeAttribute('aria-invalid');
        }
      });
      return ok;
    }

    if (next) next.addEventListener('click', function () {
      if (!validateStep(current)) return;
      if (current < TOTAL_STEPS) { current++; render(); }
    });
    if (prev) prev.addEventListener('click', function () {
      if (current > 1) { current--; render(); }
    });

    // hash inicial
    var m = /#p([1-4])/.exec(location.hash || '');
    if (m) current = Number(m[1]);
    render();
  }

  function fireInput(el) {
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setupCep(root, form) {
    // Encontra inputs pelo label
    function findByLabel(kw) {
      var labels = form.querySelectorAll('label');
      for (var i = 0; i < labels.length; i++) {
        var t = norm(labels[i].textContent);
        if (t.indexOf(norm(kw)) === 0 || t === norm(kw)) {
          var id = labels[i].getAttribute('for');
          if (id) {
            var el = form.querySelector('#' + CSS.escape(id));
            if (el) return el;
          }
          var el2 = labels[i].parentElement && labels[i].parentElement.querySelector('input, textarea, select');
          if (el2) return el2;
        }
      }
      // fallback: contém
      for (var j = 0; j < labels.length; j++) {
        if (norm(labels[j].textContent).indexOf(norm(kw)) !== -1) {
          var id2 = labels[j].getAttribute('for');
          if (id2) {
            var el3 = form.querySelector('#' + CSS.escape(id2));
            if (el3) return el3;
          }
        }
      }
      return null;
    }

    var cep = findByLabel('cep');
    if (!cep) return;
    var endereco = findByLabel('endere');
    var cidade = findByLabel('cidade');
    var estado = findByLabel('estado');
    var endpoint = root.getAttribute('data-cep-endpoint') || 'https://viacep.com.br/ws/';

    cep.addEventListener('input', function () {
      var raw = (cep.value || '').replace(/\D/g, '');
      if (raw.length !== 8) return;
      var url = endpoint + raw + '/json/';
      var ctrl = ('AbortController' in window) ? new AbortController() : null;
      var t = ctrl ? setTimeout(function () { ctrl.abort(); }, 4000) : null;
      fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (t) clearTimeout(t);
          if (!d || d.erro) return;
          if (endereco && !endereco.value) { endereco.value = d.logradouro || ''; fireInput(endereco); }
          if (cidade && !cidade.value) { cidade.value = d.localidade || ''; fireInput(cidade); }
          if (estado && !estado.value) {
            // select vs input
            if (estado.tagName === 'SELECT') {
              var opts = estado.options;
              for (var i = 0; i < opts.length; i++) {
                if (norm(opts[i].value) === norm(d.uf) || norm(opts[i].textContent).indexOf(norm(d.uf)) === 0) {
                  estado.selectedIndex = i; break;
                }
              }
            } else {
              estado.value = d.uf || '';
            }
            fireInput(estado);
          }
        })
        .catch(function () { /* silencioso */ });
    });
  }

  function boot() {
    var root = document.querySelector('[data-steps-root]');
    if (!root) return;

    var tries = 0;
    var maxTries = 30; // ~3s a 100ms
    var timer = setInterval(function () {
      tries++;
      if (activate(root)) { clearInterval(timer); return; }
      if (tries >= maxTries) { clearInterval(timer); /* fallback: nada acontece */ }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();